import * as React from "react";
import { Clock, PhoneMissed, CalendarX, CircleAlert } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const problemStats = [{
  title: "EHR Integration",
  icon: Clock,
  stat: "Instant",
  description: "Our portal syncs directly with your existing EHR, allowing medical staff to verify and dispatch prescriptions in seconds without double-entry."
}, {
  title: "Patient Tracking",
  icon: PhoneMissed,
  stat: "Real-Time",
  description: "Monitor every shipment from pharmacy to doorstep. Reduce administrative calls by giving your team a live view of patient delivery statuses."
}, {
  title: "Compliance Vault",
  icon: CalendarX,
  stat: "100%",
  description: "Automated digital signatures and HIPAA-compliant documentation are stored for every delivery, ensuring your clinic stays audit-ready."
}];
export default function TheHiddenCostOfMissedLeads() {
  return <section data-section-id="223375" id="integration-benefits" className="bg-background text-foreground py-24 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/5 via-background to-background pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center gap-2 px-3 py-1.5 mb-6 rounded-lg bg-secondary/10 border border-secondary/20 text-secondary-foreground text-sm font-medium">
            <CircleAlert className="size-4 text-secondary" />
            <span>Clinical Efficiency Redefined</span>
          </div>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight mb-6 text-foreground">
            Seamless Integration for Atlanta's Top Clinics
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default">
            GOTMEDS.IO bridges the gap between your medical practice and the patient's home. Our doctor-facing portal is designed for speed, security, and absolute reliability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {problemStats.map((item, i) => <Card key={i} data-index={i} className="bg-card/80 backdrop-blur-md border-border/50 hover:border-primary/50 transition-all duration-300 shadow-lg hover:shadow-xl">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 border border-primary/20">
                  <item.icon className="size-6 text-primary" />
                </div>
                <CardTitle className="font-default text-xl font-bold text-foreground">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="mb-4">
                  <span className="font-default text-5xl font-bold text-primary tracking-tighter">
                    {item.stat}
                  </span>
                </div>
                <p className="text-muted-foreground leading-relaxed font-default">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}